<template>
  <div class="f18-l21-m margin-top-25 " v-html="text"></div>
</template>
<script>
export default {
  props: ["text"]
}
</script>